// Windows 8 mobile Responsive utility
if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
  var msViewportStyle = document.createElement('style')
  msViewportStyle.appendChild(
    document.createTextNode(
      '@-ms-viewport{width:auto!important}'
    )
  )
  document.querySelector('head').appendChild(msViewportStyle)
}

jQuery(document).ready(function () {
  // LazyLoading
  jQuery("img").unveil(500, function () {
    jQuery(this).on('load', function () {
      jQuery(this).removeAttr("data-src");
    });
  });
  if(jQuery("#image").length) {
    var waypoint = new Waypoint({
      element: document.getElementById('image'),
      handler: function(direction) {
        jQuery("#image").addClass("view");
      },
        offset: '25%'
    });
  }
});
jQuery(document).on('click', '.menu a[href^="#"], .intro__continue, .intro__how a[href^="#"]', function (event) {
	event.preventDefault();
	jQuery('html, body').animate({
			scrollTop: jQuery($.attr(this, 'href')).offset().top
	}, 500);
});
